<template>
    <div class="form-group" :class="wrapClasses">
        <input
            :data-element="checkDataElement(dataElement ? dataElement : dataElementPrefix + 'checkbox-' + name)"
            type="checkbox"
            :id="inputId"
            :checked="checked"
            :disabled="disabled"
            @change="$emit('change', $event.target.checked)"
        />
        <label :data-element="checkDataElement(dataElementPrefix + 'label-'+name)" :for="inputId" v-html="label"></label>
    </div>
</template>

<script>
/* global Mango */
export default {
    name: "FieldCheckbox",
    model: {
        prop: 'checked',
        event: 'change'
    },
    props: {
        dataElement: String,
        dataElementPrefix: String,
        checked: Boolean,
        disabled: Boolean,
        label: String,
        error: Boolean,
        name: String,
        id: String,
    },
    data() {
        let inputId = this.$props.id ? this.$props.id : 'checkbox_' + Math.round(Math.random() * 1e6);
        return {
            inputId: inputId
        }
    },
    computed: {
        wrapClasses() {
            let classes = [];

            if (this.error && !this.disabled) {
                classes.push('has-error');
            }

            if (this.checked) {
                classes.push('has-value');
            }

            return classes
        }
    },
    methods: {
        checkDataElement(id) {
            return Mango.checkDataElement(id);
        }
    }
}
</script>

<style scoped>

</style>